import Wysiwyg from './WysiwygContent'

export default Wysiwyg
